import data from './_data';
import methods from './_methods';

export default {
    name: 'ModalWarningAction',
    data,
    methods,
    props: {
        action: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    }
};
